import { getListName } from 'analytics/enhanced-ecommerce'
import { getIsLuxPlusToursEnabled } from 'checkout/selectors/tourV2Selectors'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import Places from 'constants/places'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import { useAppSelector } from 'hooks/reduxHooks'
import { getSearchQueryFromFilter } from 'lib/search/searchUtils'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { LUX_PLUS_MONTH_CAMPAIGN_ID } from 'takeovers/luxPlusMonthTakeover/constants/luxPlusMonthTakeoverConstants'

const FILTERS: App.OfferListFilters = {
  offerTypes: ['tour_v2'],
  luxPlusFeatures: ['Member prices'],
  campaigns: [LUX_PLUS_MONTH_CAMPAIGN_ID],
  destinations: [Places.Anywhere.id],
  sortBy: 'homepage',
  limit: 20,
}

const ALL_LINK = `/search/tours?${getSearchQueryFromFilter(FILTERS)}`

interface Props {
  analyticsPage: string
}

function LuxPlusMonthToursOfferCarousel({ analyticsPage }: Props) {
  const intl = useIntl()
  const isLuxPlusToursEnabled = useAppSelector(getIsLuxPlusToursEnabled)
  const tracking = useOfferListTracking(getListName('OfferList', analyticsPage, 'Tour member prices'))

  const title = useMemo(
    () =>
      intl.formatMessage(
        {
          id: 'nCjISL-QfF2WAgBZZzQq',
          defaultMessage: '<i>More once-in-a-lifetime</i> tours for LuxPlus+ Month',
          description: 'Title for LuxPlus Month tours carousel with italicized "once-in-a-lifetime"',
        },
        {
          i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
        },
      ),
    [intl],
  )

  if (!isLuxPlusToursEnabled) return null

  return <OfferListEventsProvider tracking={tracking}>
    <OfferCardCarouselSection
      tileSize="medium"
      title={title}
      filters={FILTERS}
      allLink={ALL_LINK}
      hideWhenEmpty
      id="discounted_tours"
    />
  </OfferListEventsProvider>
}

export default LuxPlusMonthToursOfferCarousel
